const normalizeText = (value) => {
  const normalized = value?.trim?.() ?? "";
  return normalized.length > 0 ? normalized : "";
};

const getLocalDateValue = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export function buildOperatingHourRows(siteDetail) {
  const weekday = normalizeText(siteDetail?.weekday_operating_hours);
  const weekendHoliday = normalizeText(siteDetail?.weekend_holiday_operating_hours);

  if (weekday || weekendHoliday) {
    return [
      weekday ? { key: "weekday", label: "주중", text: weekday } : null,
      weekendHoliday
        ? { key: "weekendHoliday", label: "주말·공휴일", text: weekendHoliday }
        : null,
    ].filter(Boolean);
  }

  const legacy = normalizeText(siteDetail?.operating_hours);
  return legacy ? [{ key: "legacy", label: null, text: legacy }] : [];
}

export function getApplicableOperatingHourKey(date = new Date(), holidayDates = []) {
  const dateValue = getLocalDateValue(date);
  const day = date.getDay();
  if (day === 0 || day === 6 || holidayDates.includes(dateValue)) {
    return "weekendHoliday";
  }
  return "weekday";
}

export function isCurrentlyOpen(operatingHoursStr, date = new Date()) {
  if (!operatingHoursStr) return null;
  const currentHour = date.getHours();
  const currentMinute = date.getMinutes();
  const timeMatch = operatingHoursStr.match(/(\d{1,2}):(\d{2})\s*[-~]\s*(\d{1,2}):(\d{2})/);
  if (timeMatch) {
    const [, startH, startM, endH, endM] = timeMatch.map(Number);
    const currentMinutes = currentHour * 60 + currentMinute;
    const startMinutes = startH * 60 + startM;
    const endMinutes = endH * 60 + endM;
    return currentMinutes >= startMinutes && currentMinutes <= endMinutes;
  }
  return null;
}
